<template>

  <g>

    <Elliptical
      v-if    = "shape.type === 'ellipse'"
      :class  = "{ selectable: canSelect }"
      :shape  = "shape"

      @contextmenu = "$emit('contextmenu', $event);"
      @mousedown   = "$emit('mousedown', $event);"
    >
    </Elliptical>

    <PolygonalShape
      v-if    = "shape.type === 'polygon'"
      :class  = "{ selectable: canSelect }"
      :shape  = "shape"

      @contextmenu = "$emit('contextmenu', $event);"
      @mousedown   = "$emit('mousedown', $event);"
    >
    </PolygonalShape>
      
    <Rectangle
      v-if    = "shape.type === 'rectangle'"
      :class  = "{ selectable: canSelect }"
      :shape  = "shape"

      @contextmenu = "$emit('contextmenu', $event);"
      @mousedown   = "$emit('mousedown', $event);"
    >
    </Rectangle>

  </g>

</template>

<script>

// #region Imports

/* Telestream */
import { Elliptical, PolygonalShape, Rectangle } from './';

// #endregion Imports

export default {

  // #region Properties

  props: {
    shape:     Object,
    canSelect: Boolean
  },
  components: {
    Elliptical,
    PolygonalShape,
    Rectangle
  },

  // #endregion Properties

}

</script>

<style scoped>

.selectable {
  cursor: pointer;
}

</style>
